import { createThemeCompiler } from '../../../utils';
export const timePickerThemeCompiler = createThemeCompiler(({ borderRadius, stroke }) => ({
    timePicker: {
        colors: {},
        composites: {
            calloutBorderRadius: borderRadius.curvedSmall,
            optionsBorderWidth: stroke.none
        }
    }
}));
